// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    createSettings,
    //  deleteSettings,
    getSettingsApi,
    updateSettings,
} from '../../api/SettingsApi'; // Adjust the path as needed
import {
    getSettingsSuccess,
    getSettingsFailure,
    createSettingsSuccess,
    createSettingsFailure,
    updateSettingsSuccess,
    updateSettingsFailure,
    updateUserCredentialsSuccess,
    updateUserCredentialsFailure,
    // deleteSettingsSuccess,
    // deleteSettingsFailure,
} from './actions';
import { updateEmployeeCredentials } from '../../api/EmployeeApi';

// Saga to handle fetching Settingss
function* fetchSettingsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getSettingsApi, action.payload);
        yield put(getSettingsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(getSettingsFailure(errorMessage));
    }
}

// // Saga to handle creating a Settings
function* createSettingsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createSettings, action.payload);
        yield put(createSettingsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(createSettingsFailure(errorMessage));
    }
}

// // Saga to handle updating a Settings
function* updateSettingsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateSettings, action.payload.data, action.payload.id);
        yield put(updateSettingsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(updateSettingsFailure(errorMessage));
    }
}

function* updateUserCredentialsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateEmployeeCredentials, action.payload.data, action.payload.id);
        yield put(updateUserCredentialsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
                ? error.message
                : 'An unexpected error occurred';

        yield put(updateUserCredentialsFailure(errorMessage));
    }
}

// // Saga to handle updating a Settings
// function* deleteSettingsSaga(action: any): Generator<any, any, any> {
//     try {
//         const data = yield call(deleteSettings, action.payload.id);
//         yield put(deleteSettingsSuccess(data));
//     } catch (error: any) {
//         yield put(deleteSettingsFailure(error.message));
//     }
// }

export default function* SettingsSaga() {
    yield takeEvery('GET_SETTINGS_REQUEST', fetchSettingsSaga);
    yield takeEvery('CREATE_SETTINGS_REQUEST', createSettingsSaga);
    yield takeEvery('UPDATE_SETTINGS_REQUEST', updateSettingsSaga);
    yield takeEvery('UPDATE_USER_CREDENTIALS_REQUEST', updateUserCredentialsSaga);
    // yield takeEvery('DELETE_SETTINGS_REQUEST', deleteSettingsSaga);
}
